import PropTypes from 'prop-types';
import React from 'react';

const Metric = ({ label, big, sub, color }) => (
  <div style={{ background: 'var(--sl-bg-primary)', border: '1px solid var(--sl-border-secondary)', borderRadius: 12, padding: '20px 24px' }}>
    <div style={{ fontSize: 14, color: 'var(--sl-text-tertiary)' }}>{label}</div>
    <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginTop: 8 }}>
      <span style={{ fontSize: 30, fontWeight: 600, color: color || 'var(--sl-text-primary)' }}>{big}</span>
      {sub ? <span style={{ fontSize: 12, color: 'var(--sl-text-quaternary)' }}>{sub}</span> : null}
    </div>
  </div>
);

Metric.propTypes = {
  label: PropTypes.string.isRequired,
  big: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  sub: PropTypes.string,
  color: PropTypes.string,
};

Metric.defaultProps = { sub: null, color: null };

export default Metric;
